
// 安全打开消息链接
export function openMsgLink({linkUrl, newTarget}) {
  let resUrl = linkUrl
  if (linkUrl.startsWith('{crm-url}')) {
    resUrl = linkUrl.replace('{crm-url}', window.location.origin + '/learning')
  } else if (linkUrl.startsWith('{school-url}')) {
    resUrl = linkUrl.replace('{school-url}', window.location.origin + '/learning')
  }
  console.log('resUrl', resUrl)
  const a = document.createElement("a");
  a.setAttribute("target", newTarget ? "_blank" : "_self");
  a.setAttribute("href", resUrl);
  a.setAttribute("style", "display:none");
  document.body.appendChild(a);
  a.click();
  a.parentNode.removeChild(a);

}
